"use client";
import { AnimatePresence, motion } from "framer-motion";
import useNetworkStatus from "../../hooks/useNetworkStatus";

const NetworkConnection = () => {
  const { isOnline, isSlow } = useNetworkStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            width: "100%",
            background: "#ff4d4f",
            color: "#fff",
            textAlign: "center",
            padding: "6px",
            fontSize: "14px",
            position: "fixed",
            top: 0,
            zIndex: 9999,
          }}
        >
          ⚠️ No Internet Connection
        </motion.div>
      )}

      {isOnline && isSlow && (
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            width: "100%",
            background: "#faad14",
            color: "#000",
            textAlign: "center",
            padding: "6px",
            fontSize: "14px",
            position: "fixed",
            top: 0,
            zIndex: 9999,
          }}
        >
          ⚠️ Check Internet Connection
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NetworkConnection;
